export default function isExternalLink(input: string | undefined): boolean {
  return /^(https?|file|ftps?|javascript|data:image\/[^;]{2,9};):/i.test(
    input ?? '',
  );
}
